// App.tsx
import React, { useState } from 'react';
import { Box, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import router from './Routes/routes';
import { theme } from './Theme/theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CustomCursor from './Components/CustomCursor';
import Preloader2 from './Components/Preloader2';
// import { CustomCursor } from './Components/CustomCursor'; // Use named import
import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/500.css";
import "@fontsource/playfair-display/600.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/300.css";
import "@fontsource/lato/900.css";
<link
  href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap"
  rel="stylesheet"
/>

// Create a new instance of QueryClient     
// import ChatEmbedLauncher from './components/ChatEmbedLauncher';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <Box className="App">
          {/* <CustomCursor />
          <RouterProvider router={router} />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          /> */}

          {isLoading ? (
            // Display Preloader if still loading
            // <Preloader2
            //   videoSrc="https://dprstorage.b-cdn.net/RW/whitepreloder.mp4"
            //   onEnd={() => setIsLoading(false)} // Set loading to false when the Preloader finishes
            // />
            <Preloader2
              desktopVideoSrc="https://dprstorage.b-cdn.net/RW/whitepreloder.mp4"
              mobileVideoSrc="https://dprstorage.b-cdn.net/RW/mobilepreloder.mp4"
              onEnd={() => setIsLoading(false)}
            />
          ) : (
            <>
              {/* RouterProvider is loaded once the Preloader finishes */}
              <RouterProvider router={router} />
              <CustomCursor />
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </>
          )}
          {/* ⬇️ Add the launcher once, so it shows on every page */}
          {/* <ChatEmbedLauncher
            photoUrl="https://dprstorage.b-cdn.net/RW/rwimage1.jpg"
            // title="Chat with Rajiv"
            scriptUrl="https://www.noupe.com/embed/0199667711cc72c0ae45451e7e30ab0ef46d.js"
          /> */}
        </Box>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
